import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/cases/listpage/telecommunications/Template'

const Telecommunications: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'事例 実績 information technology 情報処理サービス ソフトウェア 受託開発 情報提供サービス 情報通信'}
        image={'https://www.i3design.jp/ogp_logo.png'}
        url={'https://www.i3design.jp/cases/telecommunications/'}
        title={`IT/情報/通信 | 事例 | i3DESIGN アイスリーデザイン`}
        description="IT/情報/通信のケーススタディを紹介します｜クラウドネイティブ、AI駆動開発、デザインシステムに精通した様々な支援実績がございます。UX/UIデザイン、モダンスタック技術、CI/CD、DevOps環境、AIエージェントをフル活用した開発スタイルで顧客のデジタルシフトを支援します。"
      />
      <Template pageId={1} />
    </>
  )
}

export default Telecommunications
